export const RU = {
    translations: {
        notifications: 'Уведомления',
        markAllAsRead: 'Пометить все как прочитанные',
        poweredBy: 'При поддержке',
        settings: 'Настройки',
        noNewNotification: 'Здесь пока ничего нового',
    },
    lang: 'ru',
};
//# sourceMappingURL=ru.js.map